
/**
 * Configuración de la aplicación variables no asociadas.
 * @namespace Config
 * @property {string} BASE_URL_FILTER - URL base de la API drillbi-extdata-test.
 * @property {string} BASE_URL_TABLES - URL base de la API drillbi-outputdata-test.
 * @property {string} BASE_URL_WELL - URL base de la API drillbi-extdata-test.
 * @property {string} BASE_RUN_WELL - URL base de la API drillbi-run-test/runbifilters.
 * @property {string} BASE_URL_STREAM - URL base de la API drillbistrm-test/streamingoutputrt.
 * @property {string} BASE_URL_STREAM_TABLES - URL base de la API drillbistrm-test/streamingoutputtables.
 * @property {string} BASE_URL_STREAM_DATA - URL base de la API drilloptim-strm-prod.
 * @property {string} BASE_URL_STREAM_DEPTH - URL base de la API drilloptim-strm-prod/startdepth.
 * @property {string} BASE_URL_RUN_API - URL base de la API drillbi-run-test/runbidrillmain.
 * @property {string} BASE_URL_LIST_SCENARIO - URL base de la API /drillbi-scenarios-testscenarioslist.
 * @property {string} BASE_URL_SCENARIO - URL base de la API drillbi-scenarios-test/scenario.
 * @property {string} BASE_URL_PLAN_SCENARIO - URL base de la API drillbi-scenarios-test/plan.
 */

export const config = {
    API:{
        PORT_DB : process.env.REACT_APP_PORT_DB,
        PORT_STREAMING: process.env.REACT_APP_PORT_STREAMING,
        PORT_STREAM: process.env.REACT_APP_PORT_STREAM,
        PORT_STREAM_ADMIN: process.env.REACT_APP_PORT_STREAM_ADMIN,
        BASE_URL_FILTER : process.env.REACT_APP_BASE_URL_FILTER,
        BASE_URL_TABLES: process.env.REACT_APP_BASE_URL_TABLES,
        BASE_URL_WELL : process.env.REACT_APP_BASE_URL_FILTER,
        BASE_RUN_WELL : process.env.REACT_APP_BASE_URL_RUN_API,
        BASE_URL_STREAM : process.env.REACT_APP_BASE_URL_STREAM,
        BASE_URL_STREAM_TABLES : process.env.REACT_APP_BASE_URL_STREAM,
        BASE_URL_STREAM_DATA : process.env.REACT_APP_BASE_URL_STREAM_DATA,
        BASE_URL_STREAM_DEPTH : process.env.REACT_APP_BASE_URL_STREAM_DATA,
        BASE_URL_RUN_API : process.env.REACT_APP_BASE_URL_RUN_API,
        BASE_URL_LIST_SCENARIO : process.env.REACT_APP_BASE_URL_SCENARIO,
        BASE_URL_SCENARIO : process.env.REACT_APP_BASE_URL_SCENARIO,
        BASE_URL_PLAN_SCENARIO : process.env.REACT_APP_BASE_URL_SCENARIO
    },
    // Streams API keys and credentials are added server-side by nginx (see nginx/
    // and services/API/apiAuth.js); they must not be referenced here, or the build
    // would embed them in the bundle.
}

export const keyIntegration = {
    keyEncrypt : process.env.REACT_APP_KEYENCRYPT,
}

